import React from 'react';
import { fmt } from '../kuroco/fmt';

const yen = (v) => fmt('currency', v);
/** ¥109.5万 のような短い金額表示。1 万円に満たないときは、そのまま円で。 */
const compactYen = (v) => (v >= 10000 ? `¥${Math.round(v / 1000) / 10}万` : yen(v));

/** ペースとの差（pt）の表示。正 = 遅れ、負 = 先行。判定できない間（null）は出さない。 */
function paceGapText(gap) {
  if (gap == null) return null;
  if (gap > 0) return `${gap}pt 遅れ`;
  if (gap < 0) return `${-gap}pt 先行`;
  return 'ペースどおり';
}

/**
 * 店舗の上段: 目標を設定した人の売上（大きい数字）／目標、白線 = 月の経過、達成率・残り・必要（1 日あたり）。
 * 色（バー・遅れ／先行）は、サーバーの status（pace で判定）。判定できない間は、色なし。
 * hero = utils/storeView.heroModel の結果。人数（n 名）は管理者だけ（hero.holderCount）。
 */
export default function StoreHero({ hero }) {
  if (!hero) return null;
  const title = hero.holderCount != null ? `目標を設定した${hero.holderCount}名の売上` : '目標を設定したスタッフの売上';
  const gap = paceGapText(hero.paceGap);

  return (
    <section className={`sv-hero sv-tone--${hero.tone}`} aria-label="目標を設定したスタッフの売上">
      <div className="sv-hero-head">
        <div className="sv-hero-t">{title}</div>
        {hero.period && <div className="sv-hero-p">{hero.period}</div>}
      </div>
      {!hero.hasGoals ? (
        <div className="sv-hero-empty">目標が設定されていません</div>
      ) : (
        <>
          <div className="sv-hero-main">
            <div className="sv-hero-big">
              <span className="sv-hero-v">{hero.holderSales == null ? '—' : yen(hero.holderSales)}</span>
              <span className="sv-hero-goal">／ 目標 {yen(hero.target)}</span>
            </div>
            <div className="sv-bar-wrap">
              <div className="sv-bar" aria-hidden="true">
                <i style={{ width: `${Math.min(100, hero.salesPct ?? 0)}%` }} />
              </div>
              {hero.elapsedPct != null && (
                <span className="sv-bar-mark" style={{ left: `${Math.min(100, hero.elapsedPct)}%` }} aria-hidden="true" />
              )}
            </div>
            {hero.elapsedPct != null && (
              <div className="sv-pace">
                <span>白線＝月の経過 {hero.elapsedPct}%</span>
                {gap && <span className="sv-pace-gap">{gap}</span>}
              </div>
            )}
          </div>
          <div className="sv-hero-stats">
            <div className="sv-hero-stat">
              <div className="sv-k">達成率</div>
              <div className="sv-v sv-v--pct">{hero.salesPct == null ? '—' : `${hero.salesPct}%`}</div>
            </div>
            <div className="sv-hero-stat">
              <div className="sv-k">残り</div>
              <div className="sv-v">{hero.remainingAmount == null ? '—' : compactYen(hero.remainingAmount)}</div>
            </div>
            <div className="sv-hero-stat">
              <div className="sv-k">必要{hero.remainingDays > 0 ? `（${hero.remainingDays}日）` : ''}</div>
              <div className="sv-v">{hero.requiredPerDay == null ? '—' : `${compactYen(hero.requiredPerDay)}/日`}</div>
            </div>
          </div>
        </>
      )}
    </section>
  );
}
